export const findDefaultLabel = (list) => {
  return list?.find((el) => !!el.case_default) ?? null;
}

export const findEmptyRiskScoreLabel = (list) => {
  return list?.find((el) => !el.max_label_score || !el.min_label_score) ?? null;
}